import { Tabs } from '@cloudscape-design/components';
import { templateRegistry } from '../templates/registry';

interface TypeFilterTabsProps {
  counts: Record<string, number>;
  total: number;
  selectedType: string | null;
  onTypeChange: (type: string | null) => void;
}

/**
 * Horizontal filter tabs above the configuration table.
 * One tab per unique configType with badge showing count.
 * "All" tab shows total count.
 * Sub-type templates (e.g. queue-features-announcements) are consolidated under their parent configType.
 *
 * Requirements: 7.1–7.12
 */
export function TypeFilterTabs({ counts, total, selectedType, onTypeChange }: TypeFilterTabsProps) {
  // Deduplicate: only show one tab per unique configType (use the first displayName encountered)
  const seen = new Set<string>();
  const configTypeTabs: { id: string; label: string; disabled: boolean }[] = [];
  for (const [key, template] of templateRegistry) {
    if (key === template.configType && !seen.has(template.configType)) {
      seen.add(template.configType);
      const count = counts[template.configType] ?? 0;
      configTypeTabs.push({
        id: template.configType,
        label: `${template.displayName} (${count})`,
        disabled: count === 0,
      });
    }
  }

  const tabs = [
    {
      id: 'all',
      label: `All (${total})`,
    },
    ...configTypeTabs,
  ];

  return (
    <Tabs
      activeTabId={selectedType ?? 'all'}
      onChange={({ detail }) => {
        onTypeChange(detail.activeTabId === 'all' ? null : detail.activeTabId);
      }}
      tabs={tabs}
    />
  );
}
